import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_5: FaireProductEntity = {
  token: "plant-dyed-5",
  type: "product",
  name: "Hand Dyed Bamboo Socks",
  brandName: "Mira Blackman",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5657f1a7794606f75fa66ed581731d04379105fbff98e91912aecd1578f4eaae.png",
  priceDollars: 5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/5657f1a7794606f75fa66ed581731d04379105fbff98e91912aecd1578f4eaae.png",
  weight: 0.1,
  dimensions: {
    width: 4,
    height: 8,
    depth: 1,
  },
  description: "Hand dyed bamboo socks with plant-based colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "bamboo",
    "socks",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
